var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpGraph01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1125 675",
    style: {
      enableBackground: "new 0 0 1125 675"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st1{fill:#548E25;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.87,523.7c-2.68-4.26-5-7.93-7.81-12.4c26.81-11.13,53.07-22.08,79.38-32.94 c136.25-56.25,272.54-112.4,408.68-168.88c7.84-3.25,14.13-2.97,21.8,0.17c53.81,22.04,107.76,43.76,161.85,65.13 c4.38,1.73,10.95,1.79,15.06-0.26c128.65-64.19,257.12-128.74,385.61-193.26c2.14-1.08,4.14-2.45,8.13-4.85 c-20.88-4.2-39.76-7.99-59.84-12.02c0.76-4.55,1.44-8.66,2.36-14.13c28.4,5.53,56.19,10.93,84.93,16.52 c-5.48,28.3-10.8,55.83-16.39,84.7c-4.84-0.84-9.2-1.59-14.26-2.47c3.73-19.53,7.27-38.07,11.19-58.63 c-4.95,2.39-8.39,3.99-11.78,5.7c-130.02,65.57-260.06,131.08-389.96,196.9c-7.3,3.7-13.17,3.82-20.54,0.76 c-53.05-21.97-106.33-43.41-159.35-65.46c-7.68-3.2-14.03-3.23-21.69-0.08c-154.6,63.54-309.29,126.85-463.97,190.2 C26.92,520.17,22.56,521.84,17.87,523.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpGraph01);
export default __webpack_public_path__ + "static/media/arrow-up-graph-01.dea49412dab24e66b899ffd525668d88.svg";
export { ForwardRef as ReactComponent };